import { useEffect, useRef, useState } from 'react';

const navItems = [
  { id: 'hot', label: '今日热闻' },
  { id: 'paoliao', label: '圈子爆料' },
  { id: 'deep', label: '深度观察' },
  { id: 'people', label: '幕后人物' },
  { id: 'rank', label: '热度榜单' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于我们' },
];

interface HeaderProps {
  onSearch: (q: string) => void;
}

export default function Header({ onSearch }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(keyword.trim());
    setOpen(false);
    document.getElementById('paoliao')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'border-b border-background-200/80 bg-background-50/95 shadow-sm backdrop-blur'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-base font-bold text-white">
            99
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            99爆料
          </span>
        </a>

        <nav className="ml-4 hidden flex-1 items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 lg:flex">
          <form onSubmit={handleSearch} className="flex items-center">
            <input
              ref={searchInputRef}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索圈内消息…"
              aria-label="搜索圈内消息"
              className="w-44 rounded-md border border-background-200 bg-background-100/70 px-3 py-2 text-sm text-foreground-900 outline-none transition-all focus:w-56 focus:border-primary-300"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="-ml-9 flex h-8 w-9 items-center justify-center rounded-r-md bg-transparent text-foreground-500 transition-colors hover:text-primary-600"
            >
              <i className="ri-search-line text-base" />
            </button>
          </form>
          <a
            href="#contact"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-600"
          >
            我要投稿
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50/90 text-foreground-900 lg:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center gap-2">
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索圈内消息…"
              aria-label="搜索圈内消息"
              className="flex-1 rounded-md border border-background-200 bg-background-100 px-3 py-2 text-sm outline-none focus:border-primary-300"
            />
            <button
              type="submit"
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-white"
              aria-label="搜索"
            >
              <i className="ri-search-line text-base" />
            </button>
          </form>
          <div className="grid grid-cols-2 gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-3 block rounded-md bg-primary-500 px-4 py-2 text-center text-sm font-medium text-white"
          >
            我要投稿
          </a>
        </div>
      )}
    </header>
  );
}